import React, { useState } from "react"
import { Checkbox } from "../../components/shared/fields/Checkbox"
import { mutationRequest } from "../../util/request"

export const UserCheckbox = ({ userId, name, value }) => {
  const [checked, setChecked] = useState(!!value)

  const handleUpdateUserData = async (userId, userUpdateData) => {
    try {
      let responseData = await mutationRequest({
        path: `/api/v1/users/${userId}`,
        options: { method: "PUT" },
        data: { user: userUpdateData },
      })
      return responseData
    } catch (error) {
      console.log("Error updating user data: ", error)
    }
  }

  const toggleValue = () => {
    var updateData = {}
    updateData[name] = !checked
    handleUpdateUserData(userId, updateData)
    setChecked(!checked)
  }

  return (
    <Checkbox
      name={name}
      value={value}
      checked={checked}
      onChange={toggleValue}
    />
  )
}
